import { get } from 'lodash-es'

export function getParametersFromSchema(schema: any) {
  if (!schema.$ref)
    return {}
  const [_, ...keys] = schema.$ref.split('/') // #/definitions/PR104Schema - ['definitions', 'PR104Schema']
  const { properties } = get(schema, keys.join('.')) // get(jsonSchema, 'schema.definitions.PR104Schema')
  return properties
}
